import Vue from 'vue';
import { storageService } from "../../services/StorageService.js"
import { modalService } from '../../services/ModalService.js'
import i18n from "../../language.js";

export function removeSchool({ state }, payload){

    // are you sure?
    modalService.createModal(i18n.t('language.delete_school_sure')).then(
      () => { 
        var school=payload.school;
        let index = state.user_schools.indexOf(school);
        if(index !== -1) {
          state.user_schools.splice(index, 1);
          Vue.$toaster.toast("language.school_deleted_success");
        }

        // and save in local
        var user_schools=[...state.user_schools];
        storageService.setItem('user_schools', JSON.stringify(user_schools) );

      },
    () => { /* cancel*/ }
    )  
  }
